<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">edit</i>
                        </div>
                        <h4 class="card-title ">Editar</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <div 
                                        class="form-group"
                                        v-bind:class="{'has-danger' : validation.logo != '' }">
                                        <file-upload
                                            class="btn btn-primary"
                                            :multiple="false"
                                            :size="1024 * 1024 * 10"
                                            v-model="files"
                                            @input-filter="inputFilter"
                                            @input-file="inputFile"
                                            ref="upload">
                                            <i class="fa fa-plus"></i>
                                            Selecione o Logo
                                        </file-upload>
                                        <label v-if="validation.logo != ''" id="logo-error" class="error" for="logo" style="clear: both; display: block;">{{ validation.logo }}</label>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.name" />
                                        <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.cpf_cnpj != '', 'has-danger' : validation.cpf_cnpj != '' }">
                                        <label for="cpf_cnpj" class="bmd-label-floating">CPF/CNPJ</label>
                                        <the-mask type="text" class="form-control" v-model="form.cpf_cnpj" :mask="['###.###.###-##', '##.###.###/####-##']"></the-mask>
                                        <label v-if="validation.cpf_cnpj != ''" id="cpf_cnpj-error" class="error" for="cpf_cnpj">{{ validation.cpf_cnpj }}</label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group">
                                        <md-tooltip md-direction="top">Define se a FILIAL está ativa</md-tooltip>
                                        Ativo?
                                       <div class="togglebutton">
                                            <label>
                                                <input type="checkbox" v-model="form.is_active" value="1" />
                                                <span class="toggle"></span>
                                                Sim
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.cep != ''}">
                                        <label for="cep" class="bmd-label-floating">CEP <span class="text-danger">*</span></label>
                                        <the-mask ref="cep" type="text" class="form-control" v-model="form.cep" v-on:blur.native="searchCep" :mask="'##.###-###'" />
                                        <label v-if="validation.cep != ''" id="cep-error" class="error" for="address">{{ validation.cep }}</label>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.address != ''}">
                                        <label for="address" class="bmd-label-floating">Endereço</label>
                                        <input ref="address" type="text" class="form-control" v-model="form.address" />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group is-filled"
                                            v-bind:class="{'has-danger': validation.city.state.id != ''}">
                                        <label for="state" class="bmd-label-floating">Estado <span class="text-danger">*</span></label>
                                        <model-list-select
                                            class="form-control"
                                            :list="states"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.city.state.id"
                                            @input="onSelectState">
                                        </model-list-select>
                                        <label v-if="validation.city.state.id != ''" id="complement-error" class="error" for="complement">{{ validation.city.state.id }}</label>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group bmd-form-group is-filled"
                                            v-bind:class="{'has-danger': validation.city.id != ''}">
                                        <label for="city" class="bmd-label-floating">Cidade <span class="text-danger">*</span></label>
                                        <model-list-select
                                            class="form-control"
                                            :list="cities"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.city_id">
                                        </model-list-select>
                                        <label v-if="validation.city.id != ''" id="complement-error" class="error" for="complement">{{ validation.city.id }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-10">
                                    <goal-grid 
                                    gridTitle="Edição de metas para loja"
                                    :items="form.goals"
                                    @add="addGoal"
                                    id="goal-grid"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons 
                                v-bind:to-back="{name: 'branches.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>    
    import DefaultService from '@/services/modules/defaults.service';
    import GoalGrid from '@/views/Goals/Grid';
    import Validation from '@/services/validations.service';

    export default {
        components : {
            GoalGrid,
        },
        computed: {
            form() {
                return this.$store.state.branches.item;
            },
            states: {
                set(_states) {

                },
                get() {
                    return this.$store.state.defaults.states;
                }
            },
        },
        created() {
            this.getData();
            setTimeout(_ => {
                if(!this.form.goals.length)
                    this.addGoal({});
            }, 1000);
        },
        data() {
            return {
                cities: [],
                files: [],
                validation: {
                    city: {
                        id: '',
                        state: {
                            id: ''
                        }
                    },
                    cpf_cnpj: '',
                    name: ''
                }
            };
        },
        methods: {
            addGoal( item ){
                this.form.goals.push( item );
            },
            async getDataStates() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('defaults/states');

                response.then(function () {
                    if (self.form.city != undefined && self.form.city.state != undefined && self.form.city.id != '' && self.form.city.state.id != '') {
                        var index = (self.states.findIndex(states => states.id == self.form.city.state.id) + 1);
                        self.onSelectState(index);
                    }

                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            searchCep(_ev) {
                _ev.preventDefault();

                var self = this;

                var cep = self.form.cep.replace(/\D/g, '');

                if (cep.length < 8) {
                    return false;
                }

                self.$root.$emit("onLoading");

                const response = DefaultService.searchCep(cep);

                response.then(function (_response) {
                    self.$root.$emit("onLoading");

                    if (_response.resultado > 0) {
                        var index = (self.states.findIndex(states => states.id == _response.state_id) + 1);

                        self.onSelectState(index);

                        self.form.city.state.id = _response.state_id;

                        self.form.city_id = _response.city_id;

                        self.form.address = _response.tipo_logradouro + " " + _response.logradouro;
                    } else {
                        self.$notify.error("Esse CEP não existe. Cadastrar o endereço manualmente!");
                    }
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            inputFile(newFile, oldFile) {
                var form = this.form;
                const reader = new FileReader();

                form.logo = {
                    name: '',
                    contentType: '',
                    content: ''
                };
                if (newFile && !oldFile) {
                    const file = this.getBase64(newFile.file);

                    file.then(function (data) {
                        form.logo = {
                            name: newFile.name,
                            contentType: newFile.type,
                            content: data
                        };
                    });
                }
                if (newFile && oldFile) {
                    // update
                    console.log('update', newFile)
                }
                if (!newFile && oldFile) {
                    // remove
                    console.log('remove', oldFile)
                }
            },
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Before adding a file
                    // 添加文件前
                    // Filter system files or hide files
                    // 过滤系统文件 和隐藏文件
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }
                    // Filter php html js file
                    // 过滤 php html js 文件
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
            },
            onSelectState(_index) {
                this.cities = this.states[_index - 1].cities;
            },
            onSubmit(_ev) {
                var valid = true;
                var self = this;

                self.validation.name = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.cpf_cnpj !== "") {
                    if (self.form.cpf_cnpj.length === 11) {
                        if (!Validation.cpf(self.form.cpf_cnpj)) {
                            self.validation.cpf_cnpj = "CPF inválido!";
                            valid = false;
                        }
                    } else if (self.form.cpf_cnpj.length === 14) {
                        if (!Validation.cnpj(self.form.cpf_cnpj)) {
                            self.validation.cpf_cnpj = "CNPJ inválido!";
                            valid = false;
                        }
                    } else {
                        self.validation.cpf_cnpj = "Campo inválido!";
                        valid = false;
                    }
                }

                console.log(this.form);

                if (valid) {
                    self.$root.$emit('onLoading');
                    
                    const response = self.$store.dispatch('branches/edit', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Filial atualizada com sucesso!");
                        self.$router.push({'name': 'branches.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.name !== undefined) {
                                self.validation.name = err.data.errors.name[0];
                            }
                        }
                    });
                }
                
                _ev.preventDefault();
            },
            async getData() {
                var self = this;
                
                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('branches/get', this.$route.params.id);
                
                response.then(function(){
                    self.$root.$emit('onLoading');
                    self.getDataStates();
                });
                
                response.catch(function(){
                    self.$root.$emit('onLoading');
                    self.$router.push({'name': 'branches.index'});
                });
            }
        }
    };
</script>
<style scoped>
    #goal-grid{ margin-top: 50px;}
</style>